export const debounce = (func, delay = 600, immediate = false) => {
	let timeout;
	return function () {
		const context = this;
		const args = arguments;
		const later = function () {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		const callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, delay);
		if (callNow) func.apply(context, args);
	};
};

export const IsValidIPV4 = (ipv4) => {
	const ipv4Pattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
	return ipv4Pattern.test(ipv4);
 };

 export const ExtractDomain = (url) => {
	try {
		if (IsValidDomain(url))
			return url

		let parsedURL = new URL(url);
		let domain = parsedURL.hostname;
		return domain;
	} catch (err) {
		if (err) {
			console.log(err)
			return ""
		}
	}
};

export const IsValidDomain = (domain) => {
	const domainPattern = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
	return domainPattern.test(domain);
};